import { Review } from "src/config/reviewsPerProduct";
import SingleReviewCard from "./SingleReviewCard";
import ThemeButton from "src/components/button/ThemeButton";
import { useState } from "react";
import { useTranslations } from "next-intl";
import ReviewFormModal from "src/sections/homepage/modals/ReviewForm/ReviewFormModal";

interface ReviewsListProps {
  reviews: Review[];
  productHandle: string;
}

const ReviewsList = ({ reviews, productHandle }: ReviewsListProps) => {
  const t = useTranslations("ProductOverview");
  const [showMoreReviews, setShowMoreReviews] = useState(false);
  const [openReviewForm, setOpenReviewForm] = useState(false);
  return (
    <>
      <div className="flex flex-col items-center gap-2.5">
        <ul className="block shrink gap-2.5 py-6 md:columns-2">
          {!showMoreReviews &&
            reviews
              .slice(0, 4)
              .map((review: Review, index: number) => (
                <SingleReviewCard key={index} review={review} />
              ))}
          {showMoreReviews &&
            reviews.map((review: Review, index: number) => (
              <SingleReviewCard key={index} review={review} />
            ))}
        </ul>
        <div className="adjacent-items w-full justify-center">
          <ThemeButton
            onClick={() => setOpenReviewForm(true)}
            className="w-full text-center"
          >
            {t("write_a_review")}
          </ThemeButton>
          {!showMoreReviews && (
            <ThemeButton
              onClick={() => setShowMoreReviews(true)}
              className="shemsiBtn-reverse w-full text-center"
            >
              {t("read_more")}
            </ThemeButton>
          )}
        </div>
      </div>
      <ReviewFormModal
        open={openReviewForm}
        setOpen={setOpenReviewForm}
        product={productHandle}
      />
    </>
  );
};

export default ReviewsList;
